<template>
    <div class="page-base">
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: 'LayoutBase',
    };
</script>

<style scoped></style>
